import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(all)/accounts/[currency]/deposit/page.tsx");
